import { render, staticRenderFns } from "./Compras.vue?vue&type=template&id=30ebc78c&"
import script from "./Compras.vue?vue&type=script&lang=js&"
export * from "./Compras.vue?vue&type=script&lang=js&"
import style0 from "./Compras.vue?vue&type=style&index=0&id=30ebc78c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports